import { InjectionToken } from '@angular/core';
import { Method } from 'eurogard-pattern';

export const TABLE_CREATE_REMOTE_METHOD = new InjectionToken<Method>('table-create-remote-method');
